// extracted by mini-css-extract-plugin
module.exports = {"button":"NavigationMenuClassesFromWP_button__WVsLQ"};